<div class="advanced-settings">
  <div class="content">
    <div class="tabs-setting">
      <a routerLink="/advanced-settings/preferences" routerLinkActive="active">Preferences</a>
      <a routerLink="/advanced-settings/tags" routerLinkActive="active">Tags</a>
      <a routerLink="/advanced-settings/Seo" routerLinkActive="active" *ngIf="validSubscription">Seo</a>
    </div>
    <div class="content__title">
      Preferences
      <button class="my-button-3" (click)="startTutorials()">Start Tutorials</button>
    </div>
    <div class="content__box">
      <label class="toggle" for="buyerContact">
        <div class="setting-preview">
          <p class="text-center">Preview</p>
          <img loading="lazy" src="../../../../../../assets/images/settings/allowBuyerWhatsApp.png" alt="" />
        </div>
        <input type="checkbox" name="buyerContact" [(ngModel)]="userInfo.buyerContact" class="toggle__input"
          (change)="allowWhatsappChange()" id="buyerContact" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path
                  d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                </path>
              </svg>
            </span>
          </span>
        </span>
        Allow Buyer to Contact via Whatsapp
      </label>
      <!---------->
      <label class="toggle" for="allowTelegramContact">
        <div class="setting-preview">
          <p class="text-center">Preview</p>
          <img loading="lazy" src="../../../../../../assets/images/settings/allowChatTelegram.png" alt="" />
        </div>
        <input type="checkbox" (change)="allowTelegramContactChange()" name="allowTelegramContact"
          [(ngModel)]="userInfo.allowTelegramContact" class="toggle__input" id="allowTelegramContact" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path
                  d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                </path>
              </svg>
            </span>
          </span>
        </span>
        Allow Buyer to Contact via Telegram
      </label>
      <label class="toggle" for="showCardOnProducts">
        <div class="setting-preview">
          <p class="text-center">Preview</p>
          <img loading="lazy" src="../../../../../../assets/images/settings/showCard.png" alt="" />
        </div>
        <input type="checkbox" name="showCardOnProducts" [(ngModel)]="userInfo.showCardOnProducts" class="toggle__input"
          id="showCardOnProducts" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path
                  d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                </path>
              </svg>
            </span>
          </span>
        </span>
        Show Card on my products
      </label>
      <!--showCardOnProducts-->
      <div class="d-flex mb-3 main-toggle" style="position: relative">
        <div class="setting-preview">
          <p class="text-center">Preview</p>
          <img loading="lazy" src="../../../../../../assets/images/settings/allowChatAI.png" alt="" />
        </div>
        <label class="toggle" for="allowBotChat">
          <input type="checkbox" name="allowBotChat" [(ngModel)]="userInfo.allowBotChat" class="toggle__input"
            id="allowBotChat" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path
                    d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                  </path>
                </svg>
              </span>
            </span>
          </span>
          Allow AI To Talk On My Behalf
        </label>
        <span *ngIf="userInfo.allowBotChat" (click)="openAISettingTab(AISettingTabModal)"
          style="font-size: 18px; cursor: pointer" class="ml-2 my-auto"><i class="fa-solid fa-gear"></i></span>
      </div>

      <label class="toggle" for="addMainAIInMyChat">
        <div class="setting-preview">
          <p class="text-center">Preview</p>
          <img loading="lazy" src="../../../../../../assets/images/settings/addMainAI.png" alt="" />
        </div>
        <input type="checkbox" name="addMainAIInMyChat" [(ngModel)]="userInfo.addMainAIInMyChat" class="toggle__input"
          id="addMainAIInMyChat" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path
                  d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                </path>
              </svg>
            </span>
          </span>
        </span>
        Add Main AI Chat in my inbox
      </label>
      <label class="toggle" for="sendMeEmailWhenNewChatStarts">
        <div class="setting-preview">
          <p class="text-center">Preview</p>
          <img loading="lazy" src="../../../../../../assets/images/settings/allowEmailWhenChat.png" alt="" />
        </div>
        <input type="checkbox" name="sendMeEmailWhenNewChatStarts" [(ngModel)]="userInfo.sendMeEmailWhenNewChatStarts"
          class="toggle__input" id="sendMeEmailWhenNewChatStarts" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path
                  d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                </path>
              </svg>
            </span>
          </span>
        </span>
        Send me an email when a new chat is started.
      </label>
      <!---------->
      <!-- <label class="toggle" for="tutorials">
      <input type="checkbox" name="tutorial" [checked]="tutorials" (change)="onTutorialsChange($event)" class="toggle__input" id="tutorials" />
      <span class="toggle-track">
        <span class="toggle-indicator">
          <span class="checkMark">
            <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
              <path d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z"></path>
            </svg>
          </span>
        </span>
      </span>
      Active Tutorial
    </label> -->
    </div>

    <div class="content__title">Profile Character</div>

    <div class="content__box w-full">
      <button class="my-button-3" (click)="setProfileToDefault()"><i class="fa-solid fa-user-check"></i> Set Profile to
        Default</button>
      <button class="my-button-3 ml-3" (click)="setProfileToAvatar()"><i class="fa-solid fa-user-check"></i> Set Profile
        to Avatar</button>
    </div>

    <div class="content__title">Dashboard</div>
    <div class="content__box">
      <label class="toggle">Show Category Tabs in All Services</label>
      <ng-container *ngFor="let i of categoryTabs">
        <div class="sub-cate__item" [ngClass]="{ active: i.checked }">
          <input [id]="i?.name" style="opacity: 1; width: 20px" type="checkbox" [(ngModel)]="i.checked" />
          <label [for]="i?.name">{{ i?.name | titlecase }}</label>
        </div>
      </ng-container>
    </div>

    <div class="content__title">Notifications</div>
    <div class="content__box">
      <label class="toggle" for="turnOffWhatsapp">
        <div class="setting-preview">
          <p class="text-center">Preview</p>
          <img loading="lazy" src="../../../../../../assets/images/settings/allowBookNow.png" alt="" />
        </div>
        <input type="checkbox" name="turnOffWhatsapp" [(ngModel)]="userInfo.turnOffWhatsapp" class="toggle__input"
          id="turnOffWhatsapp" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path
                  d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                </path>
              </svg>
            </span>
          </span>
        </span>
        Whatsapp Booking Notification
      </label>
      <label class="toggle" for="showMeNotifications">
        <input type="checkbox" name="showMeNotifications" [(ngModel)]="userInfo.showMeNotificationWeb"
          class="toggle__input" id="showMeNotifications" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path
                  d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                </path>
              </svg>
            </span>
          </span>
        </span>
        Send me web notifications
      </label>
    </div>

    <div class="content__title">Shop</div>
    <div class="content__box">
      <label class="toggle" for="template">
        <input type="checkbox" name="template" [(ngModel)]="userInfo.enableTemplate" class="toggle__input"
          id="template" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path
                  d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                </path>
              </svg>
            </span>
          </span>
        </span>
        Enable Template Option (For Product Creation)
      </label>
      <!-- <label class="toggle" for="showMeNotifications">
      <input type="checkbox" name="showMeNotifications" [(ngModel)]="showMeNotifications" class="toggle__input" id="showMeNotifications" />
      <span class="toggle-track">
        <span class="toggle-indicator">
          <span class="checkMark">
            <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
              <path d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z"></path>
            </svg>
          </span>
        </span>
      </span>
      Send me notifications on Apps
    </label> -->
    </div>
    <button class="my-button-3 d-flex m-auto" (click)="saveProfileInfo()"><i class="fa-solid fa-save"></i> Save</button>
  </div>
</div>

<ng-template #AISettingTabModal let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <div class="card rounded-lg border-0 mb-3 p-3">
      <div class="card-body">
        <app-my-tabs [tabs]="AISettingsTab">
          <div tab0>
            <app-chatlearn></app-chatlearn>
          </div>
          <div tab1>
            <app-chatmemory></app-chatmemory>
          </div>
        </app-my-tabs>
      </div>
    </div>
  </div>
</ng-template>